import React from 'react';
import { Modal, Typography, Button } from 'antd';
import ButtonRow from 'components/common/ButtonRow';
import { Industry } from 'types/Industry';

type IndustryDeleteModalProps = {
  industry: Industry;
  isModalVisible: boolean;
  onSubmit: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  closeModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const IndustryDeleteModal = (props: IndustryDeleteModalProps) => {
  return (
    <Modal
      title={'Delete Industry'}
      visible={props.isModalVisible}
      onCancel={props.closeModal}
      footer={null}
    >
      <Typography.Paragraph strong>
        Are you sure you want to delete this industry? 
      </Typography.Paragraph>
      <Typography.Paragraph>{props.industry.name}</Typography.Paragraph>
      <Typography.Paragraph>This will return an error if this industry is in use.</Typography.Paragraph>
      <ButtonRow style={{ marginTop: '2em' }}>
        <Button type="primary" onClick={props.onSubmit}>
          Delete
        </Button>
        <Button onClick={props.closeModal}>Cancel</Button>
      </ButtonRow>
    </Modal>
  );
};

export default IndustryDeleteModal;